import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Title } from '@angular/platform-browser';
import 'hammerjs';
import * as $ from "jquery";
import { DesignService } from './service/design.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild('modal') 
  modal: ElementRef

  title = 'Buildflex Forms';
  version: string = environment.VERSION;

  get isProduction(): boolean {
    return environment.name == "production"
  }

  constructor(
    private titleService: Title,
    private designService: DesignService) {
  }

  ngOnInit() {
    let policyTitle = this.designService.getPageTitle()

    if(policyTitle) {
      this.title = policyTitle
    }

    this.titleService.setTitle(this.title);

    const faviconUrl = this.designService.getFaviconUrl();
    this.updateFavicon(faviconUrl);
  }

  updateFavicon(url: string): void {
    let favIcon: HTMLLinkElement = document.querySelector('#favIcon');
    favIcon.href = `${url}?v=${new Date().getTime()}`;
  }
}
